import api from 'api'
import { ICertificate } from 'models/certificate.model'
import { decamelizeThatDontBreaksFile, ObjectToFormDataWithFiles } from 'helpers/converters.helper'

const createCertificate = (data: ICertificate) => {
  const decamelizeData = decamelizeThatDontBreaksFile(data)
  const formData = ObjectToFormDataWithFiles(decamelizeData, 'certificate')

  return api.post('/administration/certificates', formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export default createCertificate
